import styles from "./PodcastSubscribeBlock.module.css";
import { handleTrackClick } from "~lib/analytics/handleTrackClick";
import uncertainPodcastThumbnailUrl from "~/assets/uncertain-podcast-thumbnail.jpg";
import scienceQuicklyThumbnailUrl from "~/assets/sq-podcast-thumbnail.jpg";

export function PodcastSubscribeBlock({ podcastSeriesInfo = null }) {
  // If there is no podcast series info, don't render the component.
  if (podcastSeriesInfo === null) {
    return;
  }
  const isScienceTalk = podcastSeriesInfo?.slug === "science-talk";

  const podcastThumbnailSrc = isScienceTalk
    ? uncertainPodcastThumbnailUrl
    : scienceQuicklyThumbnailUrl;

  return (
    <>
      <div className={styles.podcast_subscribe}>
        <a href={`/podcast/${podcastSeriesInfo?.slug}`}>
          <img
            className={styles.podcast_subscribe_thumbnail}
            alt={podcastSeriesInfo.image_alt_text}
            src={podcastThumbnailSrc}
          />
        </a>
        <div className={styles.podcast_subscribe_links}>
          <div className={styles.subscribe_links_title}>SUBSCRIBE TO {podcastSeriesInfo.title}</div>
          <div className={styles.subscribe_links}>
            <a
              target="_blank"
              href={podcastSeriesInfo.apple_url}
              onClick={(e) => {
                handleTrackClick("podcast-subscribe-apple", e);
              }}
            >
              Apple
            </a>{" "}
            |{" "}
            <a
              target="_blank"
              href={podcastSeriesInfo.spotify_url}
              onClick={(e) => {
                handleTrackClick("podcast-subscribe-spotify", e);
              }}
            >
              Spotify
            </a>{" "}
            |{" "}
            {podcastSeriesInfo.pocketcasts_url && (
              <a
                target="_blank"
                href={podcastSeriesInfo.pocketcasts_url}
                onClick={(e) => {
                  handleTrackClick("podcast-subscribe-pocketcasts", e);
                }}
              >
                PocketCasts&nbsp;&#124;&nbsp;
              </a>
            )}
            {podcastSeriesInfo.youtube_url && (
              <a
                target="_blank"
                href={podcastSeriesInfo.youtube_url}
                onClick={(e) => {
                  handleTrackClick("podcast-subscribe-youtube", e);
                }}
              >
                YouTube&nbsp;&#124;&nbsp;
              </a>
            )}
            <a
              target="_blank"
              href={podcastSeriesInfo.rss_url}
              onClick={(e) => {
                handleTrackClick("podcast-subscribe-rss", e);
              }}
            >
              RSS
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
